var heroku_link = "https://dove-otp.herokuapp.com/";
var site_url = 'https://www.dove-india.com';
let countdown;
function timer(seconds,state) {
  clearInterval(countdown);
  const now = Date.now();
  const then = now + seconds * 1000;
  displayTimeLeft(seconds,state);
  
  //displayEndTime(then);
  countdown = setInterval(() => {
      
    const secondsLeft = Math.round((then - Date.now()) / 1000);
    if(secondsLeft < 0) {
      clearInterval(countdown);
          $('.resend_button').css('display','block');
          $('.resend_button_reg').css('display','block');
          $('.resend_otp_message').css('display','none');
      return;
    }else{
         $('.resend_button').css('display','none');
          $('.resend_button_reg').css('display','none');
          $('.resend_otp_message').css('display','block');
    }
    displayTimeLeft(secondsLeft,state);
  }, 1000);
}

function displayTimeLeft(seconds,state){
	const minutes = Math.floor(seconds/60);
	const remainderSeconds = seconds % 60; 
	const display = `${minutes}:${remainderSeconds < 10 ? '0' : '' }${remainderSeconds}`;``
	////console.log(display);
      if(state == "login"){
        	var counter = document.getElementById("resendcountdown");
        }else{
        	var counter = document.getElementById("resendcountdown_reg");
        }
    counter.innerHTML =  display;
}
//function mobileVerification(mobNumber,state){
function user_register(mobNumber,register_emailID,register_lastName,register_firstName,state){  
    $("#error_without_from_submit_mobile_reg").html("").hide();
    $("#error_without_from_submit_mobile").html("").hide();
    $("#Otp_sent_msg").hide();
    $("#Otp_sent_msg_reg").hide();
    $(".error_login").hide();
    $(".error_login_phone").hide();
    var add_phone_number =  $("#add_phone_number").val();
  if(add_phone_number == ""){
    add_phone_number = 0;
  }
  //console.log(mobNumber);
  var mobUrl = heroku_link +"v1_send_otp.php?register_emailID="+register_emailID+"&mobile_number="+mobNumber+"&state="+state+"&addMobile="+add_phone_number;
  //console.log(mobUrl);
  var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function() {
      if (this.readyState == 4 && this.status == 200) {
        
        //console.log("this.responseText");
        
        var json_data = JSON.parse(atob(this.responseText));
        ////console.log(json_data);
        var status = json_data.status;
        
        ////console.log(status);
        if(status == "errorNet"){
        }else if(status == "errorPhone"){
          $(".error_login_phone").show();
        }else if(status == "error"){
//           var otp_msg = json_data.msg;
//           if(otp_msg == "errorMobile"){
//             $("#add_phone_number").show();
//           }else{
//             openCity(event, 'Register');
//             var error_msg_no_reg = "Email/Mobile is not Registered."
//             $("#error_without_from_submit_mobile_reg").html(error_msg_no_reg).show();
//             //$(".error_login").show();
//           }
            var error_msg_no_reg = "Please wait for this request to expire to request for another OTP.";
            if(state == "login"){
              $("#error_without_from_submit_mobile").html(error_msg_no_reg).show();
               $('#login_get_otp').prop('disabled',false);
            }else{
            
              $("#error_without_from_submit_mobile_reg").html(error_msg_no_reg).show();
              $('#login_get_otp_reg').prop('disabled',false);
            }
          
        }else{
          ////console.log()
          timer(180,state);
          if(state == "login"){
            $("#Otp_sent_msg").show();
            var email = $("#login_mobile").val();
            var phone = json_data.data;
            phone = phone.replace("success", "");
            
            localStorage.setItem('login_email', email);
            localStorage.setItem('login_phone', phone);
            $(".resend_otp").show();
            $("#login_otp").show();
            $("#login_get_otp").hide();
            $('#login_get_otp').text("Get OTP");
            $('#login_get_otp').prop('disabled',false);
            $("#login_verify_otp").show();
          }else{
            $(".captcha_reg").hide();// captcha hide
            $("#Otp_sent_msg_reg").show();
            $(".resend_otp_reg").show();
            $("#login_otp_reg").show();
            $("#login_get_otp_reg").hide();
            $('#login_get_otp_reg').text("Get OTP");
            $('#login_get_otp_reg').prop('disabled',false);
            $("#login_verify_otp_reg").show();
          }
        

        }
      }
    };
    xhttp.open("GET", mobUrl, true);
    xhttp.send();
}
function verifyOTP(mobNumber,otpNumber,state){
  //var mobNumber = $("#login_mobile").val();
  //var otpNumber = $("#login_otp").val();
  $("#new_field_psss").hide();
  $("#new_login_button").hide();
  $(".error_login_verify").hide();
  $(".error_login_verify_reg").hide();
   $("#error_without_from_submit_mobile").html("").hide();
  //var mobotpUrl = "https://www.ens.enterprises/multibrand/lakme_otp_stage/check_otp.php?mobile_no="+mobNumber+"&otp_code="+otpNumber;
  var mobotpUrl = heroku_link+"v1_check_otp.php?state="+state+"&mobile_no="+mobNumber+"&otp_code="+otpNumber;
  ////console.log(mobotpUrl);
  var xhttp = new XMLHttpRequest();
       xhttp.onreadystatechange = function() {
         
         if (this.readyState == 4 && this.status == 200) {
             ////console.log(this.responseText);
             ////console.log("verifyOTP");
             var json_data = JSON.parse(atob(this.responseText));
             //console.log(json_data);
             //console.log(json_data.msg.length);
             var status = json_data.status;
             if(status == "error"){
          		var otp_msg = json_data.msg;
          		$(".error_login_verify").show();
                $(".error_login_verify_reg").show();
             }else if(status == "errorOtp"){ 
               var error_msg_no_reg = "Otp has been expired.";
               if(state == "login"){
                 $("#Otp_sent_msg").hide();
                 $("#error_without_from_submit_mobile").html(error_msg_no_reg).show();
                 $('#login_get_otp').prop('disabled',false);
               }else{
                 $("#Otp_sent_msg_reg").hide();
                 $("#error_without_from_submit_mobile_reg").html(error_msg_no_reg).show();
                 $('#login_get_otp_reg').prop('disabled',false);
               }
             }else if(json_data.msg.length == 50){
               
               
               if(state == "login"){
                     var json_get = json_data.data;
                     var input_email=         localStorage.getItem('input_email');
                     var input_customer_id=   localStorage.getItem('input_customer_id');
                     var input_customer_phone=localStorage.getItem('input_customer_phone');
                     var customer_state=localStorage.getItem('input_customer_state');
                     var customer_tags= localStorage.getItem('input_customer_tags');
                     var input_customer_fn=   localStorage.getItem('input_customer_fn');
                     var input_customer_ln=   localStorage.getItem('input_customer_ln');
                     var getData = "";
                    ////var customer_state = json_data.customer_state;
                    ////var customer_tags = json_data.customer_tags;
                    //var mobile_otp = customer_tags.match("Mobile_otp");
                    var mobile_otp = customer_tags.match("yes");
                    //console.log(mobile_otp);
                    //console.log(customer_state);
                    if((customer_state == "enabled") && (mobile_otp != null)){
               			login_customer_after_verification(input_customer_id);
                    }else if((customer_state == "enabled")&& (mobile_otp == null)){
                        ////console.log("aleady a user");
                        login_already_customer_after_verification(input_email,input_customer_id,input_customer_phone,input_customer_fn,input_customer_ln,json_get);

                    }else{
                      var msg_error = "You are not Registered with us "+`<p onclick="openCity(event, 'Register')" style="cursor: pointer;">Register Now</p>`;
                      $("#error_without_from_submit_mobile").html(msg_error).show();
                    }
               }else{
                   
                   reg_customer_after_verification();
               }
             }
         }
       };
       xhttp.open("GET", mobotpUrl, true);
       xhttp.send();
}
function login_customer_after_verification(get_data_cid){
  $("#error_without_from_submit_mobile").text("").hide();
   var login_email = localStorage.getItem('login_email');
   var login_get_data =  get_data_cid;
  
    // adobe_login();
    // Moengage.track_event("login", {
    //   "email":login_email
    //   //"phone":login_get_data

    // });
    // Moengage.add_email(login_email);  
    //Moengage.add_mobile(login_get_data);
    var history_prevUrl = localStorage.getItem('prevUrl');
    ////console.log(history_prevUrl);
    if(history_prevUrl != null){
      //window.location.href = history_prevUrl
    }else{
      //window.location.href = "/account";
    }
    var key = $("#login_otp").val();
    var para = "get_data_cid="+get_data_cid+"&key="+key;
    var mobotpUrl_reg = heroku_link+"v1_final_stage.php?"+para;
  
  
     var xhttp = new XMLHttpRequest();
     xhttp.onreadystatechange = function() {
       if (this.readyState == 4 && this.status == 200) {
         var json_data = JSON.parse(atob(this.responseText));
         var errors = json_data.status;
         if(errors == "success"){
            var getData = json_data.getData;
            window.location.href = site_url+ getData;
           
         }
       }
     }
     xhttp.open("GET", mobotpUrl_reg, true);
     xhttp.send();
  
//    var login_url = site_url+"login?form_type=customer_login&utf8=%E2%9C%93&customer%5Bemail%5D="+login_email+"&customer%5Bpassword%5D="+login_get_data;
//   ////console.log(login_url);
//   $.ajax({
//     url:login_url,
//     type:"post",            
//     async:false,
//     success:function(data){
//       ////console.log("data sucess=====");
//       ////console.log(data);
//       var error = $(data).find(".Alert--error").text();
//       ////console.log(error);
//       if(error == ""){
//          adobe_login();
//          Moengage.track_event("login", {
//         	"email":login_email,
//         	"phone":login_get_data
       
//         });
//          Moengage.add_email(login_email);  
//          Moengage.add_mobile(login_get_data);
//          var history_prevUrl = localStorage.getItem('prevUrl');
//          ////console.log(history_prevUrl);
//         if(history_prevUrl != null){
//           window.location.href = history_prevUrl
//         }else{
//           window.location.href = "/account";
//         }
//        }else{
//           var error_msg = "Incorrect email or password";
//           $("#error_without_from_submit_mobile").text(error_msg).show();
//        }
//     },error:function(jqXHR, exception){
     
//     }
//   });
   
  
}
function login_already_customer_after_verification(input_email,input_customer_id,input_customer_phone,input_customer_fn,input_customer_ln,get_data){
     
     var case_name = "create_user";
     var key = $("#login_otp").val();
     var para = "case="+case_name+"&input_customer_id="+input_customer_id+"&mobile="+input_customer_phone+"&email="+input_email+"&fn="+input_customer_fn+"&ln="+input_customer_ln+"&key="+key;
     var xhttp = new XMLHttpRequest();
     var mobotpUrl_reg = heroku_link+"v1_validate_progess_alreadyUser.php?"+para;
     var xhttp = new XMLHttpRequest();
     xhttp.onreadystatechange = function() {
       if (this.readyState == 4 && this.status == 200) {
         var json_data = JSON.parse(atob(this.responseText));
         var errors = json_data.status;
         
         if(errors == "error"){          
         }else{       
           var getData = json_data.getData;
           
           // adobe_login();
           // Moengage.track_event("login", {
           //   "email":input_email
           //   //"phone":input_customer_phone

           // });
           // Moengage.add_email(input_email);  
           //Moengage.add_mobile(input_customer_phone);

           var history_prevUrl = localStorage.getItem('prevUrl');
           ////console.log(history_prevUrl);
           if(history_prevUrl != null){
             //window.location.href = history_prevUrl
           }else{
             //window.location.href = "/account";
           }
           
           window.location.href = site_url+ getData;
           
//             var login_url = site_url+"login?form_type=customer_login&utf8=%E2%9C%93&customer%5Bemail%5D="+input_email+"&customer%5Bpassword%5D="+get_data;
//              $.ajax({
//                url:login_url,
//                type:"post",            
//                async:false,
//                success:function(data){
//                  //console.log("data sucess=====");
//                  //console.log(data);
//                  var error = $(data).find(".Alert--error").text();
//                  //console.log(error);
//                  if(error == ""){
//                    //adobe_register();
//                    adobe_login();
//                    Moengage.track_event("login", {
//                       "email":input_email,
//                       "phone":input_customer_phone

//                   });
//                    Moengage.add_email(input_email);  
//                    Moengage.add_mobile(input_customer_phone);
                   
//                    var history_prevUrl = localStorage.getItem('prevUrl');
//                      ////console.log(history_prevUrl);
//                     if(history_prevUrl != null){
//                       window.location.href = history_prevUrl
//                     }else{
//                       window.location.href = "/account";
//                     }
//                  }else{
//                    $("#error_without_from_submit_mobile_reg").html(error).show();
//                  }
//                },error:function(jqXHR, exception){

//                }
//            });
           
         }
       }
     };
     
     xhttp.open("GET", mobotpUrl_reg, true);
     xhttp.send();
}

function reg_customer_after_verification(){
     // adobe_register_start();
     $("#error_without_from_submit_mobile_reg").html("").hide();
     //var register_phone = $("#register_phone").val();
     var register_emailID = $("#register_emailID").val();
     var register_lastName = $("#register_lastName").val();
     var register_firstName = $("#register_firstName").val();
     var register_phone = $("#register_phone").val();
     var key = $("#login_otp_reg").val();
     
     var api ="";
     var case_name = "create_user";
     var para = "case="+case_name+"&api="+api+"&mobile="+register_phone+"&email="+register_emailID+"&fn="+register_firstName+"&ln="+register_lastName+"&key="+key;
     var xhttp = new XMLHttpRequest();
     //var mobotpUrl_reg = "https://www.ens.enterprises/multibrand/lakme_otp_stage/otp_customer.php?"+para;
     var mobotpUrl_reg = heroku_link+"v1_verify_process.php?"+para;
     xhttp.onreadystatechange = function() {
        
         if (this.readyState == 4 && this.status == 200) {
            var json_data = JSON.parse(atob(this.responseText));          
            var errors = json_data.status;
           if(errors == "error"){
             var error_msg = "";
             var error_msg_adobe = "";
             var error_dis = json_data.error_dis;
             $("#error_without_from_submit_mobile_reg").html(error_dis).show();
           //  adobe_register_error(error_dis);
           }else{
             var getData = json_data.getData;
             
             // adobe_register();
                 //   Moengage.track_event("register", {
                 //     "first_name":register_firstName,
                 //     "last_name":register_lastName,
                 //     "email":register_emailID,
                 //     "phone":register_phone
                 //   });
                 //   Moengage.add_unique_user_id("registeredID", register_emailID);
                 //   Moengage.add_first_name(register_firstName);
                 //   Moengage.add_last_name(register_lastName);
                 //   Moengage.add_email(register_emailID);
                 //   Moengage.add_mobile(register_phone);
               gigya_code(header_value,site_url,getData);//addinge this code  07-06-23
             //window.location.href = site_url+ getData;  //commented this code 07-06-23
           }
         }
       };
     
      xhttp.open("GET", mobotpUrl_reg, true);
       xhttp.send();
  
}

$(document).ready(function(){
    
   var remember = document.getElementById('myCheckbox_reg');
  
   $(".icon-popup-close").click(function(){
     // //console.log("fff");
      $(".login_otp_popup").hide();
      
   });
  
   $('#login_get_otp').click(function(){
     $("#login_mobile").css({"border":"1px solid #e3e3e3"});
     $("#error_without_from_submit_mobile_reg").html("").hide();
     var mobNumber = $("#login_mobile").val();
  
     
     if(mobNumber == ""){
       $("#login_mobile").css({"border":"1px solid red"});
       ////console.log("Please enter email number");
     }else{
       
       if($.isNumeric(mobNumber)){
         //var value_para = "input_value=phone="+mobNumber;
          var email_error_msg = "Email is invalid"
         $("#error_without_from_submit_mobile").html(email_error_msg).show();
       }else if(validateEmail(mobNumber)){
         var value_para = "input_value=email="+mobNumber;
         $('#login_get_otp').text("Get OTP");
         $('#login_get_otp').prop('disabled',true);
       
         mobile_email_details(value_para);
       }else{
         var email_error_msg = "Email is invalid"
         $("#error_without_from_submit_mobile").html(email_error_msg).show();
       }
       
//        $('#login_get_otp').text("Get OTP");
//        $('#login_get_otp').prop('disabled',true);
       
//        mobile_email_details(value_para);
       var input_errors =  localStorage.getItem('input_errors');
       if(input_errors == "error"){
         //openCity(event, 'Register');
         //var error_msg_no_reg = "Email/Mobile is not Registered."
         //$("#error_without_from_submit_mobile_reg").html(error_msg_no_reg).show();  

       }else{      
         //var input_email=         localStorage.getItem('input_email');
         //var input_customer_id=   localStorage.getItem('input_customer_id');
         //var input_customer_phone=localStorage.getItem('input_customer_phone');
         //var input_customer_state=localStorage.getItem('input_customer_state');
         //var input_customer_tags= localStorage.getItem('input_customer_tags');
         //var input_customer_fn=   localStorage.getItem('input_customer_fn');
         //var input_customer_ln=   localStorage.getItem('input_customer_ln');
         //if(input_customer_phone == ""){
         //  $("#add_phone_number").show();
         //  //console.log("opened add mobile number field");
         //  //var input_customer_phone = $("#login_mobile").val();
         //}else{
         //  user_register(input_customer_phone,input_email,input_customer_ln,input_customer_fn,"login");       
         //}


       }
     }
//      if (remember.checked){
       

//        $("#login_mobile").css({"border":"1px solid #e3e3e3"});
//        //var mobNumber = $(this).parent().find('input').val();
//        var mobNumber = $("#login_mobile").val();
//        if(mobNumber == ""){
//          $("#login_mobile").css({"border":"1px solid red"});
//          //console.log("Please enter mobile number");
//        }else{
//          //var substr = mobNumber.substring(mobNumber.length-4, mobNumber.length);
//          //$('#mobileNumberOTP').text('+91******'+substr);
//          mobileVerification(mobNumber,"login");
//        }
//      }else{
//         //$(".checkmark").css("border","2px solid #000");
//      }
    });
  
   $('#login_get_otp_reg').click(function(){
     if (remember.checked){
       $("#checkbox_msg").css("color","#fff");
       $("#register_phone").css({"border":"1px solid #e3e3e3"});
       $("#register_emailID").css({"border":"1px solid #e3e3e3"});
       $("#register_lastName").css({"border":"1px solid #e3e3e3"});
       $("#register_firstName").css({"border":"1px solid #e3e3e3"});
      //var mobNumber = $(this).parent().find('input').val();
      var mobNumber = $("#register_phone").val();
      var register_emailID = $("#register_emailID").val();
      var register_lastName = $("#register_lastName").val();
      var register_firstName = $("#register_firstName").val();
       var phone_regex = /^[6789][0-9]{4}([ ]?)[0-9]{5}$/;
       $('#phone_error_reg').hide();
      if(!phone_regex.test(mobNumber)) {
         $('#phone_error_reg').show();
      }else if(mobNumber == ""){
        $("#register_phone").css({"border":"1px solid red"});
        ////console.log("Please enter mobile number");
      }else if(register_firstName == ""){
        $("#register_firstName").css({"border":"1px solid red"});
        ////console.log("Please enter first Name number"); 
      }else if(register_emailID == ""){
        $("#register_emailID").css({"border":"1px solid red"});
        ////console.log("Please enter email number"); 
      }else if(register_lastName == ""){
        $("#register_lastName").css({"border":"1px solid red"});
        ////console.log("Please enter lastName  number");   
      }else{
          //var substr = mobNumber.substring(mobNumber.length-4, mobNumber.length);
          //$('#mobileNumberOTP').text('+91******'+substr);
          //mobileVerification(mobNumber,"reg");
          $('#login_get_otp_reg').text("Get OTP");
          $('#login_get_otp_reg').prop('disabled',true);
          var captcha = $("#g-recaptcha-response").val();
          var value_phone = "input_value=phone="+mobNumber;
          // mobile_email_details_reg(value_phone,mobNumber,register_emailID,register_lastName,register_firstName,"reg",captcha);
         mobile_email_details_reg_without_captcha(value_phone,mobNumber,register_emailID,register_lastName,register_firstName,"reg");  
        //user_register(mobNumber,register_emailID,register_lastName,register_firstName,"reg");
      }
       }else{
         $('html, body').animate({
        scrollTop: $("#checkbox_msg").offset().top - 500
    	}, 2000);
         $("#checkbox_msg").css("color","red");
        //$(".checkmark").css("border","2px solid #000");
       }
    });
  
   $('.resend_button a').click(function(){
//       var mobNumber = $("#login_mobile").val(); 
//       mobileVerification(mobNumber,"login");
//       timer(180,"login");
     
      $('#login_get_otp').trigger("click");
    });
  
   $('.resend_button_reg a').click(function(){
////       var mobNumber = $("#register_phone").val(); 
////       mobileVerification(mobNumber,"reg");
////       timer(180,"reg");
      var mobNumber = $("#register_phone").val();
      var register_emailID = $("#register_emailID").val();
      var register_lastName = $("#register_lastName").val();
      var register_firstName = $("#register_firstName").val();
     if(mobNumber == ""){
        $("#register_phone").css({"border":"1px solid red"});
        ////console.log("Please enter mobile number");
      }else if(register_firstName == ""){
        $("#register_firstName").css({"border":"1px solid red"});
        ////console.log("Please enter first Name number"); 
      }else if(register_emailID == ""){
        $("#register_emailID").css({"border":"1px solid red"});
        ////console.log("Please enter email number"); 
      }else if(register_lastName == ""){
        $("#register_lastName").css({"border":"1px solid red"});
        ////console.log("Please enter lastName  number");   
      }else{
        var value_phone = "input_value=phone="+mobNumber;
        mobile_email_details_reg_without_captcha(value_phone,mobNumber,register_emailID,register_lastName,register_firstName,"reg");
      }
      //       $('#login_get_otp_reg').trigger("click");
     
     
    });
  
   $('#login_verify_otp').click(function(){
      $(".error_login_verify").hide();
      $("#login_otp").css({"border":"1px solid #e3e3e3"});
      $("#login_mobile").css({"border":"1px solid #e3e3e3"});
          //var mobNumber = $("#login_mobile").val();
          var login_email = localStorage.getItem('login_email');
          var mobNumber =  localStorage.getItem('login_phone');
          var login_otp = $("#login_otp").val();
      if((mobNumber == "") || (login_otp == "")){
        $("#login_otp").css({"border":"1px solid red"});
        $("#login_mobile").css({"border":"1px solid red"});
        ////console.log("Please enter mobile number");
        if(login_otp == ""){
           $(".error_login_verify").show();
        }
      }else{
           verifyOTP(mobNumber,login_otp,"login");
      }
    });
  
   $('#login_verify_otp_reg').click(function(){
     console.log("this_text",$(this).text());
       $(".error_login_verify_reg").hide();
      $("#login_otp_reg").css({"border":"1px solid #e3e3e3"});
      $("#register_phone").css({"border":"1px solid #e3e3e3"});
          var mobNumber = $("#register_phone").val();
          var login_otp_reg = $("#login_otp_reg").val();
      if((mobNumber == "") || (login_otp_reg == "")){
        $("#login_otp_reg").css({"border":"1px solid red"});
        $("#register_phone").css({"border":"1px solid red"});
        ////console.log("Please enter mobile number");
        if(login_otp_reg == ""){
           $(".error_login_verify_reg").show();
        }
      }else{
          $("#Otp_sent_msg_reg").hide();
          verifyOTP(mobNumber,login_otp_reg,"reg");
          fbq('track', 'CompleteRegistration',{
          'status':'successfully registered'
          });
          const get_date = new Date();
          localStorage.setItem('set_newUser',get_date.getDay());
      }
    });
   
   $("#register_phone").on('keyup', function(e) {
     $('#login_get_otp_reg').text("Get OTP");
     $('#login_get_otp_reg').prop('disabled',false);
     var phoneNum = $(this).val();
     ////console.log(phoneNum);
     var phone_regex = /^[6789][0-9]{4}([ ]?)[0-9]{5}$/;
     //var phone_regex = /^$/;
     if(!phone_regex.test(phoneNum)) {
       $('#phone_error_reg').show();
       $('#login_get_otp_reg').prop('disabled',true);
     }
     else{
       $('#phone_error_reg').hide();
       $('#login_get_otp_reg').prop('disabled',false);
     }
     //grecaptcha.reset();
     $(".captcha_reg").show();// show captcha
     $("#login_otp_reg").val("");
     $("#login_verify_otp_reg").hide();
     $("#login_get_otp_reg").show();
     $(".resend_otp").hide();
     $("#login_otp_reg").hide();
     
   });
  
   $("#add_phone_number").on('keyup', function(e) {
     $('#login_get_otp').text("Get OTP");
     $('#login_get_otp').prop('disabled',false);
     var phoneNum = $(this).val();
     ////console.log(phoneNum);
     var phone_regex = /^[6789][0-9]{4}([ ]?)[0-9]{5}$/;
     //var phone_regex = /^$/;
     if(!phone_regex.test(phoneNum)) {
       $('#phone_error').show();
       $('#login_get_otp').prop('disabled',true);
     }
     else{
       //var value_phone = "input_value=phone="+phoneNum;
       //mobile_details(value_phone,phoneNum);
       $('#phone_error').hide();
       $('#login_get_otp').prop('disabled',false);
     }
     $("#login_otp").val("");
     $("#login_verify_otp").hide();
     
     $("#login_get_otp").show();
     
     $(".resend_otp_reg").hide();
     $("#login_otp").hide();
     
   });
  
function validateEmail(email) {
  const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}
function mobile_email_details_reg_without_captcha(value,mobNumber,register_emailID,register_lastName,register_firstName,state){
    $("#error_without_from_submit_mobile_reg").html("").hide(); 
    var mobotpUrl_reg = heroku_link+"v1_mobile_email_details.php?"+value;
     ////console.log(mobotpUrl_reg); 
    var xhttp = new XMLHttpRequest();
     xhttp.onreadystatechange = function() {
       
         ////console.log(this.status);
         ////console.log(this.readyState);
         if (this.readyState == 4 && this.status == 200) {
            ////console.log(this.responseText);
            var json_data = JSON.parse(atob(this.responseText));          
            var errors = json_data.status;
           if(errors=="error"){
               
               user_register(mobNumber,register_emailID,register_lastName,register_firstName,state);
           }else{
             
              var customer_email = register_emailID;
             var customer_id =   json_data.date;
             var customer_phone = mobNumber;
             var customer_state = "data";
             var customer_tags = json_data.data;
             var customer_fn = "data";
             var customer_ln = "data";
             
             if(customer_phone == ""){
               
               user_register(mobNumber,register_emailID,register_lastName,register_firstName,state);
             }else{
               // grecaptcha.reset();
                $('#login_get_otp_reg').text("Get OTP");
                $('#login_get_otp_reg').prop('disabled',false);
             	//var mobile_email_associated_msg_string = customer_phone +" is associated with "+customer_email; 
             	var mobile_email_associated_msg_string = customer_phone +" is associated with other email"; 
                $("#error_without_from_submit_mobile_reg").html(mobile_email_associated_msg_string).show();
             }
           }
            
          
         }
       };
     
      xhttp.open("GET", mobotpUrl_reg, true);
       xhttp.send();
}
  
function mobile_email_details_reg(value,mobNumber,register_emailID,register_lastName,register_firstName,state,captcha){
    $("#error_without_from_submit_mobile_reg").html("").hide(); 
    var mobotpUrl_reg = heroku_link+"v1_mobile_email_details_captcha.php?"+value+"&g-recaptcha-response="+captcha;
     ////console.log(mobotpUrl_reg); 
    var xhttp = new XMLHttpRequest();
     xhttp.onreadystatechange = function() {
       
         ////console.log(this.status);
         ////console.log(this.readyState);
         if (this.readyState == 4 && this.status == 200) {
            ////console.log(this.responseText);
            var json_data = JSON.parse(atob(this.responseText));          
            var errors = json_data.status;
           if(errors == "errorCaptcha"){
             var captchaError = "Captcha does not matched";
             $("#error_without_from_submit_mobile_reg").html(captchaError).show();
             grecaptcha.reset();
             $('#login_get_otp_reg').prop('disabled',false);
           }else if(errors=="error"){
               
               user_register(mobNumber,register_emailID,register_lastName,register_firstName,state);
           }else{
             var customer_email = register_emailID;
             var customer_id =   json_data.date;
             var customer_phone = mobNumber;
             var customer_state = "data";
             var customer_tags = json_data.data;
             var customer_fn = "data";
             var customer_ln = "data";
             if(customer_phone == ""){
               
               user_register(mobNumber,register_emailID,register_lastName,register_firstName,state);
             }else{
                grecaptcha.reset();
                $('#login_get_otp_reg').text("Get OTP");
                $('#login_get_otp_reg').prop('disabled',false);
             	//var mobile_email_associated_msg_string = customer_phone +" is associated with "+customer_email; 
                var mobile_email_associated_msg_string = customer_phone +" is associated with other email"; 
             	$("#error_without_from_submit_mobile_reg").html(mobile_email_associated_msg_string).show();
             }
           }
            
          
         }
       };
     
      xhttp.open("GET", mobotpUrl_reg, true);
       xhttp.send();
}
  
function mobile_email_details(value){
     var mobotpUrl_reg = heroku_link+"v1_mobile_email_details.php?"+value;
     //console.log(mobotpUrl_reg); 
    var xhttp = new XMLHttpRequest();
     xhttp.onreadystatechange = function() {
         ////console.log(this.status);
         ////console.log(this.readyState);
         if (this.readyState == 4 && this.status == 200) {
            //console.log(this.responseText);
            var json_data = JSON.parse(atob(this.responseText));          
            var errors = json_data.status;
           if(errors=="error"){
             localStorage.setItem('input_errors', errors);
             
             localStorage.setItem('input_email', "");
             localStorage.setItem('input_customer_id', "");
             localStorage.setItem('input_customer_phone', "");
             localStorage.setItem('input_customer_state', "");
             localStorage.setItem('input_customer_tags', "");
             localStorage.setItem('input_customer_fn', "");
             localStorage.setItem('input_customer_ln', "");
            
            var login_mobile_value_name = $("#login_mobile").val();
            $("#register_emailID").val(login_mobile_value_name);
			openCity(event, 'Register');
			var error_msg_no_reg = "Email is not Registered."
			$("#error_without_from_submit_mobile_reg").html(error_msg_no_reg).hide();
             
             $('#login_get_otp').text("Get OTP");
             $('#login_get_otp').prop('disabled',false);
             
           }else{
             
             var customer_email = $("#login_mobile").val();
             var customer_id =   json_data.date;
             //console.log("id");
              //console.log(customer_id);
             var customer_phone = json_data.time;
             var customer_state = json_data.captcha;
             var customer_tags = json_data.data;
             var customer_fn = "data";
             var customer_ln = "data";
             var getData = json_data.getData;
             
			if(errors=="errorBlank"){
			   var new_php_number = $("#add_phone_number").val();
               if(new_php_number == ""){			   
					$("#add_phone_number").show();
                    $('#login_get_otp').text("Get OTP");
                    $('#login_get_otp').prop('disabled',false);
					////console.log("opened add mobile number field");
			   }else{
				   var value_phone = "input_value=phone="+new_php_number;
                   mobile_details(value_phone,new_php_number,customer_email,customer_ln,customer_fn);
			   }
			   
			}else{
			   user_register(customer_phone,customer_email,customer_ln,customer_fn,"login");       
			}
			 
//             localStorage.setItem('input_errors', "");
            
             localStorage.setItem('input_email', customer_email);
             localStorage.setItem('input_customer_id', customer_id);
             localStorage.setItem('input_customer_phone', customer_phone);
             localStorage.setItem('input_customer_state', customer_state);
             localStorage.setItem('input_customer_tags', customer_tags);
             localStorage.setItem('input_customer_fn', customer_fn);
             localStorage.setItem('input_customer_ln', customer_ln);    
             
             
           }
            
          
         }
       };
     
      xhttp.open("GET", mobotpUrl_reg, true);
       xhttp.send();
}
function mobile_details(value,phone,customer_email,customer_ln,customer_fn){ 
     $("#error_without_from_submit_mobile").hide();
     var mobotpUrl_reg = heroku_link+"v1_mobile_email_details.php?"+value;
     ////console.log(mobotpUrl_reg); 
    var xhttp = new XMLHttpRequest();
     xhttp.onreadystatechange = function() {
         ////console.log(this.status);
         ////console.log(this.readyState);
         if (this.readyState == 4 && this.status == 200) {
            ////console.log(this.responseText);
            var json_data = JSON.parse(atob(this.responseText));          
            var errors = json_data.status;
           if(errors=="error"){
            localStorage.setItem('input_customer_phone', phone);  
			user_register(phone,customer_email,customer_ln,customer_fn,"login");			  
           }else{
               var error_here = "Phone has already been taken"
				$("#error_without_from_submit_mobile").text(error_here);
				$("#error_without_from_submit_mobile").show();
               ////console.log(error_here);      
             
           }            
          
         }
       };
     
      xhttp.open("GET", mobotpUrl_reg, true);
       xhttp.send();
}  
   $("#login_mobile").on('keyup', function(e) {
     
     $('#login_get_otp').text("Get OTP");
     $('#login_get_otp').prop('disabled',false);
     
     var this_value = $(this).val();
     
     if($.isNumeric(this_value)){
//        var phone_regex = /^[6789][0-9]{4}([ ]?)[0-9]{5}$/;
//        //var phone_regex = /^$/;
//        if(!phone_regex.test(this_value)) {
//          $('#phone_error').show();
//          $('#login_get_otp').prop('disabled',true);
//        }
//        else{
//          //var value_phone = "input_value=phone="+this_value;
//          //mobile_email_details(value_phone);
//          $('#phone_error').hide();
//          $('#login_get_otp').prop('disabled',false);
//        }
     }else{
       if (validateEmail(this_value)) {
         //var value_email = "input_value=email="+this_value;
         //mobile_email_details(value_email);
         $('#phone_error').hide();
         $('#login_get_otp').prop('disabled',false);
       }else{
         //$('#login_get_otp').prop('disabled',true);
       }
       
     }
     $("#login_otp").val("");
     $("#login_verify_otp").hide();
     $("#login_get_otp").show();
     $(".resend_otp_reg").hide();
     $("#login_otp").hide();
     $("#add_phone_number").hide();
     
   });
  
   $(".p5-medium-magenta").click(function(){
    // adobe_logout();
  });
   $(".krng-button-main").click(function(){
    ////console.log("window.location.href");
    ////console.log(window.location.href);
    localStorage.setItem('prevUrl' , window.location.href);
    var history_prevUrl = localStorage.getItem('prevUrl');
  });
  $('body').delegate('.btn-login','click',function() {  
         
          ////console.log("window.location.href");
          ////console.log(window.location.href);
          localStorage.setItem('prevUrl' , window.location.href);
          var history_prevUrl = localStorage.getItem('prevUrl');
          window.location.href = "/account/login";
          localStorage.setItem('openCartOnLogin' , 'yes');
      });
  if(window.theme.isCustomer != ""){
  var openCartOnLogin_value =  localStorage.getItem('openCartOnLogin');
    if(openCartOnLogin_value == "yes"){

        setTimeout(function(){
	       OpenCart();
           localStorage.setItem('openCartOnLogin' , 'no');
        }, 2000);
    }else{

    }
  }
  // address page chagnes phone number validation
  $(".phone_number_address").on('keyup', function(e) {
     ////console.log("phone_number_address keyup");
     var phoneNum = $(this).val();
     ////console.log(phoneNum);
     var phone_regex = /^[6789][0-9]{4}([ ]?)[0-9]{5}$/;
    
     if(!phone_regex.test(phoneNum)) {
       $('.phone_number_address_error').show();
       $('.submit_address_form').prop('disabled',true);
     }
     else{
       $('.phone_number_address_error').hide();
       $('.submit_address_form').prop('disabled',false);
     }

     
   });
  
});